// ============================================
// SpotChef HTML Reference - Main JavaScript Entry Point
// ============================================
// Initialize
import { initHeroSliders } from './hero-slider.js';
import { initTocFAQ } from './accordion.js';
import { initMobileMenu } from './mobile-menu.js';
import { initTabs } from './tabs.js';
import { initScrollAnimate } from './scroll-animate.js';
import { initHorizontalScroll } from './horizontal-scroll.js';
import { initCopyButtons } from './share-utils.js';

console.log('SpotChef HTML Reference loaded');

// Initialize all modules on DOM ready
document.addEventListener('DOMContentLoaded', () => {
    initHeroSliders();
    initMobileMenu();
    initTocFAQ();
    initTabs();
    initScrollAnimate();
    initHorizontalScroll();
    initCopyButtons();
});
